<div
    [ngClass]="[
        'bazis-loader_' + theme(),
        type() === 'inline'
            ? 'bazis-loader_inline'
            : type() === 'inner'
              ? 'bazis-loader_inner'
              : 'bazis-loader',
        cssClass(),
    ]"
>
    <div class="bazis-loader__content">
        @if (loader() === 'dots') {
            <div class="bazis-loader__dots">
                @for (item of [].constructor(amountDots()); track $index) {
                    <div class="bazis-loader__dot"></div>
                }
            </div>
        }

        @if (loader() === 'spinner') {
            <svg class="bazis-loader__spinner">
                <circle
                    [attr.cx]="centerX()"
                    [attr.cy]="centerY()"
                    [attr.r]="radius()"
                    fill="none"
                    stroke-width="1"
                ></circle>
            </svg>
        }
        @if (message()) {
            <p [innerHTML]="message() | safe: 'SafeHtml'"></p>
        }
        @if (messageKey()) {
            <p
                *transloco="let t"
                [innerHtml]="t(messageKey())"
            ></p>
        }
    </div>
</div>
